import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-navtoggle', 'toggleMenu', 'Pārslēgt izvēlni');
Labels.set('ui-navtoggle', 'closeMenu', 'Aizvērt izvēlni');
Labels.set('ui-navtoggle', 'close', 'Aizvērt');
